<template>
  <v-container class="legal-notice">
    <v-row>
      <v-col cols="12" lg="8" class="mx-auto">
        <h1 class="text-h3 mb-8 font-weight-medium">{{ $t('imprint.title') }}</h1>

        <v-card class="pa-8 mb-8" elevation="2">
          <section class="mb-8">
            <h2 class="text-h5 mb-4 font-weight-medium">{{ $t('imprint.legal_info.title') }}</h2>
            <address class="legal-notice__address text-body-1">
              <span>{{ $t('imprint.legal_info.company') }}</span>
              <span>{{ $t('imprint.legal_info.name') }}</span>
              <span>{{ $t('imprint.legal_info.address.street') }}</span>
              <span>{{ $t('imprint.legal_info.address.city') }}</span>
              <span>{{ $t('imprint.legal_info.address.country') }}</span>
            </address>
          </section>

          <section class="mb-8">
            <h2 class="text-h5 mb-4 font-weight-medium">{{ $t('imprint.contact.title') }}</h2>
            <p class="text-body-1 mb-2">
              <a href="mailto:support@grundriss-ai.de">
                {{ $t('imprint.contact.email_label') }} support@grundriss-ai.de
              </a>
            </p>
            <p class="text-body-1 mb-0">
              <a href="tel:+38765356789">{{ $t('imprint.contact.phone') }}</a>
            </p>
          </section>

          <section>
            <h2 class="text-h5 mb-4 font-weight-medium">{{ $t('imprint.data_protection.title') }}</h2>
            <p class="text-body-1 mb-2">{{ $t('imprint.data_protection.content') }}</p>
            <p class="text-body-1 mb-0">
              <a href="mailto:datenschutz@grundriss-ai.de">
                {{ $t('imprint.data_protection.email_label') }} datenschutz@grundriss-ai.de
              </a>
            </p>
          </section>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Impressum'
}
</script>

<style scoped>
.legal-notice {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.legal-notice__address {
  display: grid;
  gap: 0.25rem;
  font-style: normal;
}

.legal-notice a {
  color: rgb(var(--v-theme-primary));
  text-decoration: none;
}

.legal-notice a:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .legal-notice {
    padding: 1rem;
  }
}
</style>
